const parseJSON = jsonString => {
  try {
    return JSON.parse(jsonString) || {}
  } catch (e) {
    return {}
  }
}

export default parseJSON
